module.exports = __webpack_public_path__ + "prod/1.42.2/img/h5_xtrh_one.11ad062a.png";